<template>
  <div class="container py-4 py-lg-5 my-lg-5 px-4 px-sm-0">
    <div class="col-sm-12 ml-auto">
      <div class="card p-4 rounded-plus bg-faded">
        <h1 class="text-center fw-400 mb-4 d-xs-block">{{ $t('titles.confirm-account') }}</h1>

        <password-form buttonText="buttons.confirm" @setPassword="confirmAccount">
          <div class="form-group col-12">
            <terms-list
              :termsList="termsList"
              :termsIds="$schema.termsIds"
              @view="showContentModal($event.name, $event.content)"
            />
          </div>
        </password-form>
      </div>
    </div>

    <preview-modal
      :show="previewModal"
      :text="previewModalText"
      :title="previewModalTitle"
      @close="closeContentModal"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import PasswordForm from '@/components/forms/PasswordForm';
import PreviewModal from '@/components/modals/PreviewModal';
import TermsList from '@/components/TermsList';
import { formMixin } from '@/mixins/form';
import previewModalMixin from '@/mixins/previewModal.mixin';
import { authResource } from '@/resources/auth.resource';
import schema from '@/schemas/acceptTerms.schema';

// @vuese
// Potwierdzanie konta z akceptacją regulaminów
// @group Start
export default {
  name: 'ConfirmAccount',
  components: {
    PasswordForm,
    PreviewModal,
    TermsList
  },
  mixins: [formMixin, previewModalMixin],
  data() {
    return {
      model: {
        termsIds: []
      }
    };
  },
  computed: mapState({
    termsList: state => state.terms.list
  }),
  beforeCreate() {
    this.$options.external = {
      requiredLength: this.$store.state.terms.list.length
    };
  },
  methods: {
    // @vuese
    // Potwierdza konto
    confirmAccount({ password }) {
      if (!this.$schema.$validateAll().length) {
        authResource
          .acceptTerms(this.$route.params.token, password, this.model.termsIds)
          .then(() =>
            this.$store.dispatch('showConfirm', {
              title: 'Konto zostało potwierdzone',
              showCloseButton: false,
              submitButton: 'Ok',
              onSuccess: () => this.$router.push({ name: 'login' })
            })
          )
          .catch(() => this.$store.dispatch('notifyError', { title: 'messages.auth.confirmError' }));
      }
    }
  },
  external: {},
  schema
};
</script>
